<template>
  <div ref="confirmationmodal" class="modal">
    <div class="modal-dialog" role="document">
      <div class="modal-content modal-content-demo">
        <div class="modal-body tx-center pd-y-20 pd-x-20">
          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
            <span aria-hidden="true">×</span>
          </button>
          <template v-if="type=='warning'">
            <i class="ion-ios-warning tx-100 tx-indigo lh-1 mg-t-20 d-inline-block" />
            <h4 class="tx-indigo mg-b-20">Warning!</h4>
          </template>
          <template v-else-if="type=='alert'">
            <i class="on-ios-alert tx-100 tx-indigo lh-1 mg-t-20 d-inline-block" />
            <h4 class="tx-indigo mg-b-20">Alert!</h4>
          </template>
          <template v-else>
            <i class="ion-ios-alert tx-100 tx-indigo lh-1 mg-t-20 d-inline-block" />
            <h4 class="tx-indigo mg-b-20">Alert!</h4>
          </template>
          <p v-if="message" class="mg-b-20 mg-x-20">
            {{ message }}
          </p>
          <button class="mg-t-5 btn rounded btn-az-primary pd-x-25" data-dismiss="modal" type="button" @click="confirm">
            {{ buttonText }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { generatePropSyncMixin } from '@/utils/sync-prop';

import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'DeleteModalNew',
  mixins: [
    generatePropSyncMixin('internalOpen', 'open'),
  ],
  props: ['open', 'type', 'message', 'buttonText'],
  watch: {
    internalOpen(value) {
      $(this.$refs.confirmationmodal).modal(value ? 'show' : 'hide');
    }
  },
  mounted() {
    $(this.$refs.confirmationmodal).on('hidden.bs.modal', () => {
      this.internalOpen = false;
    });
  },
  methods: {
    confirm() {
      this.$emit('click');
      this.internalOpen = false;
    }
  }

}
);
</script>
